import {Expense} from '../expense';

export function toString(this: Expense) {
    return `Deal: ${this.id}`;
}
